/**
 * Hella Good Cup — Main JavaScript v2.1
 * Fixed: initCartDrawer, updateCartCount, initPopup,
 *        initFreeShippingBar, initMobileNav, initQuiz,
 *        DOMContentLoaded handler, AJAX cart, toast notifications
 */

'use strict';

// ── Utility ──────────────────────────────────────────────────────────────────
function $(sel, ctx) { return (ctx || document).querySelector(sel); }
function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ── Toast Notification ────────────────────────────────────────────────────────
function showToast(message, type) {
  var existing = $('.hgc-toast');
  if (existing) existing.remove();

  var toast = document.createElement('div');
  toast.className = 'hgc-toast' + (type ? ' hgc-toast--' + type : '');
  toast.textContent = message;
  document.body.appendChild(toast);

  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });
  });

  setTimeout(function() {
    toast.classList.remove('is-visible');
    setTimeout(function() { toast.remove(); }, 500);
  }, 3000);
}

// ── Cart State ────────────────────────────────────────────────────────────────
var HGCCart = {
  data: null,

  fetch: function() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        HGCCart.data = cart;
        HGCCart.updateCount(cart.item_count);
        return cart;
      });
  },

  updateCount: function(count) {
    var countEls = $$('#cartCount, .hgc-cart-count, [data-cart-count]');
    countEls.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  add: function(variantId, quantity, sellingPlan) {
    var body = { id: variantId, quantity: quantity || 1 };
    if (sellingPlan) body.selling_plan = sellingPlan;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) { return r.json(); });
  },

  change: function(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r) { return r.json(); });
  },

  remove: function(key) {
    return HGCCart.change(key, 0);
  }
};

// ── Cart Drawer ───────────────────────────────────────────────────────────────
function initCartDrawer() {
  var drawer = $('#hgc-cart-drawer, .hgc-cart-drawer');
  var overlay = $('#hgc-cart-overlay, .hgc-cart-overlay');
  var closeBtn = $('.hgc-cart-drawer__close');
  var cartBtns = $$('[data-open-cart], .hgc-header__icon-btn[href="/cart"], #cartIconBtn');

  if (!drawer) return;

  function openCart() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    HGCCart.fetch().then(function(cart) {
      renderCartDrawer(cart);
    });
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Expose globally
  window.hgcOpenCart = openCart;
  window.hgcCloseCart = closeCart;

  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  cartBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  });

  // Cart icon in header
  var cartIcon = $('[data-cart-icon], .hgc-header__icon-btn');
  if (cartIcon && cartIcon.getAttribute('href') === '/cart') {
    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  }
}

function renderCartDrawer(cart) {
  var itemsEl = $('.hgc-cart-drawer__items');
  var subtotalEl = $('.hgc-cart-drawer__subtotal strong, #drawerSubtotal');
  var shippingBar = $('.hgc-cart-drawer__shipping');

  // Update count
  HGCCart.updateCount(cart.item_count);

  // Update free shipping bar
  if (shippingBar) {
    var threshold = 5000; // $50.00 in cents
    var remaining = threshold - cart.total_price;
    if (cart.total_price >= threshold) {
      shippingBar.innerHTML = '🎉 <strong>FREE SHIPPING UNLOCKED!</strong>';
    } else {
      shippingBar.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more for FREE shipping!';
    }
  }

  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="hgc-cart-drawer__empty">' +
      '<svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
      '<p>Your cart is empty</p>' +
      '<a href="/collections/all" class="btn btn--primary" onclick="hgcCloseCart()">Shop Now</a>' +
      '</div>';
    if (subtotalEl) subtotalEl.textContent = '$0.00';
    return;
  }

  var html = '';
  cart.items.forEach(function(item) {
    var imgSrc = item.image
      ? item.image.replace(/(\.(jpg|jpeg|png|gif|webp))/, '_160x160$1')
      : '';
    var imgHtml = imgSrc
      ? '<img class="hgc-cart-drawer__item-img" src="' + imgSrc + '" alt="' + (item.title || '') + '" width="80" height="80" loading="lazy">'
      : '<div class="hgc-cart-drawer__item-img" style="display:flex;align-items:center;justify-content:center;font-size:2rem;background:var(--color-gray-100);">☕</div>';

    var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="hgc-cart-drawer__item-variant">' + item.variant_title + '</p>'
      : '';

    html += '<div class="hgc-cart-drawer__item" data-key="' + item.key + '">' +
      imgHtml +
      '<div class="hgc-cart-drawer__item-info">' +
        '<p class="hgc-cart-drawer__item-title">' + item.product_title + '</p>' +
        variantHtml +
        '<p class="hgc-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
        '<div class="hgc-cart-drawer__qty">' +
          '<button onclick="hgcDrawerQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button onclick="hgcDrawerQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase">+</button>' +
        '</div>' +
        '<button onclick="hgcDrawerQty(\'' + item.key + '\',0)" style="font-size:.75rem;color:var(--color-gray-400);text-decoration:underline;margin-top:.25rem;background:none;border:none;cursor:pointer;padding:0;">Remove</button>' +
      '</div>' +
    '</div>';
  });

  itemsEl.innerHTML = html;

  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
}

window.hgcDrawerQty = function(key, qty) {
  HGCCart.change(key, qty).then(function(cart) {
    renderCartDrawer(cart);
  });
};

window.hgcUpdateCartDrawer = function(cart) {
  renderCartDrawer(cart);
};

// ── Free Shipping Bar ─────────────────────────────────────────────────────────
function initFreeShippingBar() {
  var bar = $('.hgc-shipping-bar');
  if (!bar) return;

  var threshold = 5000; // $50.00 in cents

  function updateBar(cartTotal) {
    var msgEl = bar.querySelector('.hgc-shipping-bar__message');
    var fillEl = bar.querySelector('.hgc-shipping-bar__fill');
    var pct = Math.min((cartTotal / threshold) * 100, 100);

    if (fillEl) fillEl.style.width = pct + '%';

    if (msgEl) {
      if (cartTotal >= threshold) {
        msgEl.innerHTML = '🎉 You\'ve unlocked <strong>FREE SHIPPING!</strong>';
      } else {
        var remaining = threshold - cartTotal;
        msgEl.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more for <strong>FREE shipping</strong>!';
      }
    }
  }

  HGCCart.fetch().then(function(cart) {
    updateBar(cart.total_price);
  });
}

// ── Email Popup ───────────────────────────────────────────────────────────────
function initPopup() {
  var overlay = $('#hgc-popup-overlay, .hgc-popup-overlay');
  if (!overlay) return;

  var closeBtn = overlay.querySelector('.hgc-popup__close');
  var POPUP_KEY = 'hgc_popup_v2';
  var POPUP_DELAY = 8000;

  // Don't show if already seen
  if (sessionStorage.getItem(POPUP_KEY)) return;

  function showPopup() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    sessionStorage.setItem(POPUP_KEY, '1');
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePopup();
  });

  // Show after delay
  setTimeout(showPopup, POPUP_DELAY);

  // Handle form submission
  var form = overlay.querySelector('#hgcPopupForm, .hgc-popup__form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var phoneInput = form.querySelector('input[type="tel"]');
      var smsCheck = form.querySelector('#popupSmsOptIn, input[type="checkbox"]');
      var successEl = overlay.querySelector('.hgc-popup__success');

      if (!emailInput || !emailInput.value.includes('@')) return;

      var email = emailInput.value.trim();
      var phone = phoneInput ? phoneInput.value.trim() : '';
      var smsOptIn = smsCheck ? smsCheck.checked : false;

      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.innerHTML = '<span class="hgc-spinner"></span>';
        submitBtn.disabled = true;
      }

      // Klaviyo
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email, '$phone_number': phone || undefined }]);
        window._learnq.push(['track', 'Popup Signup', { email: email, sms_opt_in: smsOptIn }]);
      }

      // Mautic
      var MAUTIC_URL = 'https://mautic.brewsandteas.com';
      fetch(MAUTIC_URL + '/form/submit?formId=1', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'mauticform[email]=' + encodeURIComponent(email) +
              '&mauticform[phone]=' + encodeURIComponent(phone) +
              '&mauticform[formId]=1&mauticform[return]=&mauticform[formName]=popup_optin'
      }).catch(function() {});

      // TextLink SMS
      if (smsOptIn && phone) {
        fetch('https://api.textlinksms.com/v1/contacts', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': '42nEE1EBVkw7P7gt7AmhLga1BL9YN1aW16jdwAId8cGwssH6UTnbAuDAOvCoQqKa'
          },
          body: JSON.stringify({ phone: phone, email: email, tags: ['popup_optin', 'welcome15'] })
        }).catch(function() {});
      }

      // Pixel events
      if (window.fbq) fbq('track', 'Lead', { content_name: 'popup_optin' });
      if (window.gtag) gtag('event', 'generate_lead', { event_category: 'popup' });

      // Show success
      if (successEl) {
        successEl.style.display = 'block';
        successEl.innerHTML = '🎉 <strong>WELCOME15</strong> is on its way to your inbox! Check your email for your 15% off code.';
      }
      form.querySelector('.hgc-popup__form, .hgc-popup__input-row') && (form.style.display = 'none');

      setTimeout(closePopup, 3500);
    });
  }
}

// ── Mobile Navigation ─────────────────────────────────────────────────────────
function initMobileNav() {
  var nav = $('#hgc-mobile-nav, .hgc-mobile-nav');
  var hamburger = $('#hgc-hamburger, .hgc-hamburger, [data-hamburger]');
  var closeBtn = nav ? nav.querySelector('.hgc-mobile-nav__close') : null;
  var overlay = nav ? nav.querySelector('.hgc-mobile-nav__overlay') : null;

  if (!nav || !hamburger) return;

  function openNav() {
    nav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeNav() {
    nav.classList.remove('is-open');
    document.body.style.overflow = '';
    hamburger.setAttribute('aria-expanded', 'false');
  }

  hamburger.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeNav();
  });
}

// ── Coffee Quiz ───────────────────────────────────────────────────────────────
function initQuiz() {
  var quiz = $('#hgc-quiz, .hgc-quiz');
  if (!quiz) return;

  var steps = $$('.hgc-quiz__step', quiz);
  var dots = $$('.hgc-quiz__progress-dot', quiz);
  var resultEl = $('.hgc-quiz__result', quiz);
  var currentStep = 0;
  var answers = {};

  // Quiz data
  var quizData = {
    questions: [
      {
        id: 'roast',
        question: 'What roast level do you prefer?',
        options: [
          { emoji: '☀️', label: 'Light', value: 'light' },
          { emoji: '🌤️', label: 'Medium', value: 'medium' },
          { emoji: '🌑', label: 'Dark', value: 'dark' },
          { emoji: '🤷', label: 'Not sure', value: 'medium' }
        ]
      },
      {
        id: 'flavor',
        question: 'What flavors do you love in your cup?',
        options: [
          { emoji: '🍓', label: 'Fruity & Bright', value: 'fruity' },
          { emoji: '🍫', label: 'Chocolatey & Rich', value: 'chocolate' },
          { emoji: '🌰', label: 'Nutty & Smooth', value: 'nutty' },
          { emoji: '🌺', label: 'Floral & Complex', value: 'floral' }
        ]
      },
      {
        id: 'brew',
        question: 'How do you usually brew your coffee?',
        options: [
          { emoji: '💧', label: 'Pour Over', value: 'pour_over' },
          { emoji: '🫖', label: 'French Press', value: 'french_press' },
          { emoji: '⚡', label: 'Espresso', value: 'espresso' },
          { emoji: '☕', label: 'Drip Machine', value: 'drip' }
        ]
      },
      {
        id: 'vibe',
        question: 'What\'s your morning coffee vibe?',
        options: [
          { emoji: '🧘', label: 'Calm & Focused', value: 'calm' },
          { emoji: '🚀', label: 'Energized & Ready', value: 'energized' },
          { emoji: '🎨', label: 'Creative & Inspired', value: 'creative' },
          { emoji: '🤝', label: 'Social & Sharing', value: 'social' }
        ]
      }
    ],
    results: {
      light_fruity:    { handle: 'guatemala-single-origin', title: 'Guatemala Single Origin', desc: 'Bright, fruity, and complex — perfect for light roast lovers who appreciate terroir.' },
      light_floral:    { handle: 'guatemala-single-origin', title: 'Guatemala Single Origin', desc: 'Delicate floral notes and vibrant acidity. A true specialty coffee experience.' },
      medium_chocolate: { handle: 'cascades-blend', title: 'Cascades Blend', desc: 'Rich chocolate notes with a smooth, balanced finish. Our most popular blend.' },
      medium_nutty:    { handle: 'smith-river-blend', title: 'Smith River Blend', desc: 'Smooth, nutty, and approachable. Perfect for everyday drinking.' },
      dark_chocolate:  { handle: 'broken-top-blend', title: 'Broken Top Blend', desc: 'Bold, dark, and intensely satisfying. For those who like it strong.' },
      default:         { handle: 'cascades-blend', title: 'Cascades Blend', desc: 'Our best-selling blend — smooth, balanced, and universally loved.' }
    }
  };

  function renderStep(index) {
    steps.forEach(function(s, i) {
      s.classList.toggle('active', i === index);
    });
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === index);
      d.classList.toggle('done', i < index);
    });
  }

  function getResult() {
    var roast = answers.roast || 'medium';
    var flavor = answers.flavor || 'chocolate';
    var key = roast + '_' + flavor;
    return quizData.results[key] || quizData.results.default;
  }

  function showResult() {
    steps.forEach(function(s) { s.classList.remove('active'); });
    dots.forEach(function(d) { d.classList.add('done'); d.classList.remove('active'); });

    if (!resultEl) return;
    resultEl.classList.add('active');

    var result = getResult();
    var imgEl = resultEl.querySelector('.hgc-quiz__result-img');
    var titleEl = resultEl.querySelector('.hgc-quiz__result-title');
    var descEl = resultEl.querySelector('.hgc-quiz__result-desc');
    var ctaEl = resultEl.querySelector('.hgc-quiz__result-cta');

    if (titleEl) titleEl.textContent = result.title;
    if (descEl) descEl.textContent = result.desc;
    if (ctaEl) {
      ctaEl.href = '/products/' + result.handle;
      ctaEl.textContent = 'Shop ' + result.title + ' →';
    }

    // Try to load product image
    if (imgEl) {
      fetch('/products/' + result.handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          if (p.featured_image) {
            imgEl.src = p.featured_image.replace(/(\.(jpg|jpeg|png|gif|webp))/, '_320x320$1');
            imgEl.alt = p.title;
          }
        })
        .catch(function() {});
    }

    // Track quiz completion
    if (window.fbq) fbq('track', 'Lead', { content_name: 'quiz_complete', content_category: result.handle });
    if (window.gtag) gtag('event', 'quiz_complete', { recommended_product: result.handle });
  }

  // Render first step
  renderStep(0);

  // Option click handler
  quiz.addEventListener('click', function(e) {
    var option = e.target.closest('.hgc-quiz__option');
    if (!option) return;

    var step = option.closest('.hgc-quiz__step');
    if (!step) return;

    var questionId = step.dataset.question;
    answers[questionId] = option.dataset.value;

    // Animate selection
    $$('.hgc-quiz__option', step).forEach(function(o) { o.classList.remove('selected'); });
    option.classList.add('selected');

    setTimeout(function() {
      currentStep++;
      if (currentStep < steps.length) {
        renderStep(currentStep);
      } else {
        showResult();
      }
    }, 400);
  });

  // Restart button
  var restartBtn = quiz.querySelector('.hgc-quiz__restart');
  if (restartBtn) {
    restartBtn.addEventListener('click', function() {
      currentStep = 0;
      answers = {};
      if (resultEl) resultEl.classList.remove('active');
      renderStep(0);
    });
  }
}

// ── Announcement Bar ──────────────────────────────────────────────────────────
function initAnnouncementBar() {
  var bar = $('.hgc-announcement');
  if (!bar) return;

  // Rotate messages if multiple
  var messages = bar.querySelectorAll('[data-message]');
  if (messages.length > 1) {
    var current = 0;
    setInterval(function() {
      messages[current].style.display = 'none';
      current = (current + 1) % messages.length;
      messages[current].style.display = 'block';
    }, 4000);
  }
}

// ── Sticky Header ─────────────────────────────────────────────────────────────
function initStickyHeader() {
  var header = $('.hgc-header');
  if (!header) return;

  var lastScroll = 0;
  window.addEventListener('scroll', function() {
    var current = window.scrollY;
    if (current > 100) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    lastScroll = current;
  }, { passive: true });
}

// ── Product Card Quick Add ────────────────────────────────────────────────────
function initProductCards() {
  document.addEventListener('click', function(e) {
    var quickAddBtn = e.target.closest('[data-quick-add]');
    if (!quickAddBtn) return;

    e.preventDefault();
    var variantId = quickAddBtn.dataset.quickAdd;
    if (!variantId) return;

    quickAddBtn.innerHTML = '<span class="hgc-spinner"></span>';
    quickAddBtn.disabled = true;

    HGCCart.add(variantId, 1)
      .then(function() {
        quickAddBtn.textContent = '✓ Added!';
        quickAddBtn.style.background = 'var(--color-success)';
        showToast('Added to cart!', 'success');
        HGCCart.fetch().then(function(cart) {
          if (window.hgcUpdateCartDrawer) window.hgcUpdateCartDrawer(cart);
          if (window.hgcOpenCart) window.hgcOpenCart();
        });
        setTimeout(function() {
          quickAddBtn.textContent = 'Add to Cart';
          quickAddBtn.style.background = '';
          quickAddBtn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        quickAddBtn.textContent = 'Error';
        quickAddBtn.style.background = 'var(--color-error)';
        setTimeout(function() {
          quickAddBtn.textContent = 'Add to Cart';
          quickAddBtn.style.background = '';
          quickAddBtn.disabled = false;
        }, 2000);
      });
  });
}

// ── Newsletter Forms ──────────────────────────────────────────────────────────
function initNewsletterForms() {
  $$('.hgc-newsletter-form, .hgc-cta-banner__form, .hgc-footer__newsletter-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value.includes('@')) return;

      var email = emailInput.value.trim();
      var btn = form.querySelector('button[type="submit"]');
      var successEl = form.closest('section, .hgc-footer__col').querySelector('.hgc-newsletter-success, .hgc-cta-banner__success');

      if (btn) { btn.textContent = '...'; btn.disabled = true; }

      // Klaviyo
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email }]);
        window._learnq.push(['track', 'Newsletter Signup', { source: 'footer_form' }]);
      }

      // Mautic
      fetch('https://mautic.brewsandteas.com/form/submit?formId=2', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'mauticform[email]=' + encodeURIComponent(email) + '&mauticform[formId]=2&mauticform[formName]=newsletter'
      }).catch(function() {});

      if (successEl) {
        successEl.style.display = 'block';
        successEl.textContent = '✓ You\'re subscribed! Check your inbox.';
      }
      emailInput.value = '';
      if (btn) { btn.textContent = '✓ Done!'; }

      if (window.fbq) fbq('track', 'Lead', { content_name: 'newsletter_footer' });
    });
  });
}

// ── Scroll Animations ─────────────────────────────────────────────────────────
function initScrollAnimations() {
  if (!window.IntersectionObserver) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  $$('.hgc-product-card, .hgc-feature-card, .hgc-testimonial-card, [data-animate]').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

  document.addEventListener('animationend', function(e) {
    if (e.target.classList.contains('is-visible')) {
      e.target.style.opacity = '';
      e.target.style.transform = '';
    }
  });

  // Add CSS for is-visible
  var style = document.createElement('style');
  style.textContent = '.is-visible { opacity: 1 !important; transform: translateY(0) !important; }';
  document.head.appendChild(style);
}

// ── Mautic Tracking ───────────────────────────────────────────────────────────
function initMauticTracking() {
  var MAUTIC_URL = 'https://mautic.brewsandteas.com';
  // Load Mautic tracking script
  (function(w,d,t,u,n,a,m){
    w['MauticTrackingObject']=n;
    w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)};
    a=d.createElement(t);m=d.getElementsByTagName(t)[0];
    a.async=1;a.src=u;m.parentNode.insertBefore(a,m);
  })(window,document,'script',MAUTIC_URL+'/mtc.js','mt');
  mt('send','pageview');
}

// ── DOM Ready ─────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  initCartDrawer();
  initFreeShippingBar();
  initPopup();
  initMobileNav();
  initQuiz();
  initAnnouncementBar();
  initStickyHeader();
  initProductCards();
  initNewsletterForms();
  initScrollAnimations();
  initMauticTracking();

  // Initial cart count
  HGCCart.fetch();
});


// ============================================================
// COUNTER ANIMATION
// ============================================================
function initCounterAnimation() {
  const counters = document.querySelectorAll('[data-counter]');
  if (!counters.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const target = parseInt(el.getAttribute('data-counter'), 10);
        const suffix = el.getAttribute('data-suffix') || '';
        const prefix = el.getAttribute('data-prefix') || '';
        const duration = 2000;
        const start = 0;
        const startTime = performance.now();

        function update(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
          const current = Math.floor(eased * (target - start) + start);
          el.textContent = prefix + current.toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(update);
        }
        requestAnimationFrame(update);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.3 });

  counters.forEach(counter => observer.observe(counter));
}

document.addEventListener('DOMContentLoaded', function() {
  initCounterAnimation();
});
